import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { SkeletonBulletListComponent } from './skeleton-bullet-list.component';
import { SkeletonListComponent } from './skeleton-list.component';
import { SkeletonTableComponent } from './skeleton-table.component';
import { SkeletonComponent } from './skeleton.component';

const COMPONENTS = [
  SkeletonComponent,
  SkeletonBulletListComponent,
  SkeletonListComponent,
  SkeletonTableComponent,
];

@NgModule({
  imports: [CommonModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class SkeletonModule {
  static forRoot(): ModuleWithProviders<SkeletonModule> {
    return {
      ngModule: SkeletonModule,
    };
  }
}
